import { request } from '@/common/utils/request'

/** 获取首页拜访任务列表 */
export function getVisitTaskLsit(params) {
  return request
    .get({
      url: 'feidian.bdapp.visit.getVisitTaskList',
      params,
    })
    .then(res => res.data)
    .catch(() => {
      return false
    })
  // return request.get('http://mock.xiaojukeji.com/mock/12854/visit/getVisitTaskList', params)
}

/** 获取首页拜访数据new */
export function getHomePageVisitData(params) {
  return request
    .get({
      url: 'feidian.bdapp.visit.getHomePageVisitData',
      params,
    })
    .then(res => res.data)
    .catch(() => false)
}
